import { format } from 'date-fns';
import { memoize, isNaN } from 'lodash-es';
import moment from 'moment';

function formatDate(date) {
  if (!(date instanceof Date)) {
    if (isNaN(Date.parse(date))) {
      return 'N/A';
    }
    date = new Date(date);
  }

  return format(date, 'do MMM yyy, hh:mm:ss bbb');
}

export function getLocalDateInFormat(dt, format = 'DD/MM/YYYY') {
  const toDt = moment.utc(dt).toDate();
  return moment(toDt).format(format);
}

export default memoize(formatDate);
